import {createDomainEvent, DomainEvent} from './domain-event'

export const CatalogEventTypes = {
  FiltersApply: 'catalg.filters.apply',
} as const


export type CatalogFiltersApplyEvent = DomainEvent

export const CatalogEvents = {
  filtersApply(): CatalogFiltersApplyEvent {
    return createDomainEvent(CatalogEventTypes.FiltersApply)
  },
}
